import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import LinkIcon from "@mui/icons-material/Link";
import PrintIcon from "@mui/icons-material/Print";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ShareIcon from "@mui/icons-material/Share";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  Stack,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { AiFillSetting } from "react-icons/ai";
import { RiFileExcel2Fill } from "react-icons/ri";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import AttToken from "../../../helpers/attToken";
import { trackEventMatomo } from "../../../helpers/matomo";
import Checklists from "../../../service/Checklists";
import PrintService from "../../../service/PrintTemplate";
import queryClient from "../../../service/query";
import Reports from "../../../service/Reports";
import Tickets from "../../../service/Tickets";
import { theme } from "../../../theme";
import { ChecklistSubitem, ItemChecklist, ocorrenciaType } from "../../../types/checklist/types";
import { PrintTemplateType } from "../../../types/print-template/types";
import { ChamadosArrayType, ChecklistReportType, equipeReport } from "../../../types/reports/types";
import ModalAprovation from "../../Aprovations/Modal/ModalAprovation";
import DataDetail from "./DataDetail";
import { downloadResponsesCSV } from "./ModalExportCSV";
import ModalOptions from "./ModalOptions";
import ModalQRCode from "./ModalQRCode";
import { UserContext } from "../../../context/UserContext";
import ModalShareReports from "./ModalShareReports";

const tickets = new Tickets();
type props = {
  selected: ChecklistReportType[];
  openModal: boolean;
  setOpenModal: Function;
  commingFromFilled?: boolean;
  numberOfTicktes?: number;
  isLoadingLink?: boolean;
  inicio?: number;
  onClose?: () => void;
  reset?: Function;
  aprovadores?: string[];
  blocked?: boolean;
  refetchAprovation?: Function;
};

export type addTicketType = {
  source: import("../../../types/reports/types").TicketSource;
  active?: boolean;
};

export type campoOcultosType = {
  [key: string]: string;
};

const printTemplateService = new PrintService();
const ChecklistsService = new Checklists();

function CancelExecutionModal({ open, setOpen, handleCancel, isLoading, t }: { open: boolean, setOpen: Function, handleCancel: Function, isLoading: boolean, t: Function }) {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      scroll='paper'
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>
        {t("checklists.cancelExecution")}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpen(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers={true}>
        <Typography>
          {t("checklists.confirmCancelExecution")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLoading} onClick={() => handleCancel()}>
          {t("checklists.confirmCancellation")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function ModalDetailPrint({ selected, openModal, setOpenModal, isLoadingLink, aprovadores, blocked, refetchAprovation }: props) {
  const reportsService = new Reports();
  const { t } = useTranslation("translation");
  const [showSettings, setShowSettings] = useState(false);
  const [showHeaders, setShowHeaders] = useState(true);
  const [showNotSelected, setShowNotSelected] = useState<boolean>(false);
  const [showScoring, setShowScoring] = useState(false);
  const [openAprovation, setOpenAprovation] = useState(false);
  const [aprove, setAprove] = useState("");
  const [showHideFields, setShowHideFields] = useState(false);
  const [showLink, setShowLink] = useState(selected?.[0]?.hasLink ? true : false);
  const [hideHierarchy, setHideHierarchy] = useState({
    cliente: true,
    local: true,
    conjunto: true,
    unidade: true,
  });
  const [hideEquipe, setHideEquipe] = useState(true);
  const [hideUser, setHideUser] = useState(true);
  const [hideIdent, setHideIdent] = useState(false);
  const [hideAprov, setHideAprov] = useState(false);
  const [hideDate, setHideDate] = useState({
    inicio: true,
    fim: true,
  });
  const [hideNAplica, setHideNAplica] = useState(true);
  const [hideFiles, setHideFiles] = useState(false);
  const [radioOption, setRadioOption] = useState<string>("hide");
  const [showDuplicatas, setShowDuplicatas] = useState(false);
  const [ocultaNomeEmpresa, setOcultaNomeEmpresa] = useState(false);
  const [exibeTipo, setExibeTipo] = useState(false);
  const [showNumbers, setShowNumbers] = useState(false);
  const [temChamados, setTemChamados] = useState(false);
  const [showRange, setShowRange] = useState(false);
  const [link, setLink] = useState(
    selected[0]?.hasLink && `${process.env.REACT_APP_AXYMA_FRONT_URL}detalhe-checklist/${selected[0]?.hasLink}/${selected[0]?.username || "anonimo"}`,
  );
  const [exibeDetalheHospedeiro, setExibeDetalheHospedeiro] = useState(true);
  const [openModalCancela, setOpenModalCancela] = useState(false);
  const { userData } = useContext(UserContext);

  useEffect(() => {
    const recoveredOptions = localStorage.getItem("valoresOpcoes");
    if (recoveredOptions) {
      const parsed = JSON.parse(recoveredOptions);
      setShowHeaders(parsed?.cabecalho);
      setOcultaNomeEmpresa(parsed?.nomeEmpresa);
      setHideHierarchy({
        cliente: parsed?.cliente,
        local: parsed?.local,
        conjunto: parsed?.conjunto,
        unidade: parsed?.unidade,
      });
      setExibeTipo(parsed?.tipoSubitem);
      setShowNumbers(parsed?.numeroItem);
      setHideAprov(parsed?.listaAprovados);
      setShowScoring(parsed?.scoring);
      setHideIdent(parsed?.identificador);
      setShowNotSelected(parsed?.nSelecionado);
      setHideNAplica(parsed?.nAplica);
      setRadioOption(parsed?.chamados);
      setHideDate({
        inicio: parsed?.inicio,
        fim: parsed?.fim,
      });
      setHideUser(parsed?.usuario);
      setHideEquipe(parsed?.equipe);
      setShowRange(parsed?.range ?? true);
      setHideFiles(parsed?.arquivos ?? false);
    }
  }, []);

  useEffect(() => {
    const form = selected?.some((ele) => ele.chamados && ele?.chamados?.length > 0);
    const subitem = selected?.some((ele) =>
      ele?.itens?.some((item) => {
        return item?.ocorrenciaMultipla
          ? item?.ocorrencias?.some((oco) => oco?.subitens?.some((sub) => sub?.chamados))
          : item?.subitens?.some((sub) => sub?.chamados);
      }),
    );
    if (form || subitem) {
      setTemChamados(true);
    }
  }, [temChamados, selected]);

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["GET_PRINT_TEMPLATE"],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response = await printTemplateService.getAllTemplates(token);
        if (!response.printTemplates) throw new Error(t("Reports.modalDetailP.errorFetchingPrintTemplates"));
        return response.printTemplates;
      }
    },
    retry: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const formTemChamados = (form: ChecklistReportType): boolean | undefined => {
    if (form?.chamados?.length) {
      return true;
    }

    return form?.itens?.some((item: ItemChecklist) => {
      if (item?.ocorrenciaMultipla) {
        return item?.ocorrencias?.some((ocorrencia: ocorrenciaType) => ocorrencia?.subitens?.some((subitem: ChecklistSubitem) => subitem?.chamados?.length));
      }

      return item?.subitens?.some((subitem: ChecklistSubitem) => subitem?.chamados?.length);
    });
  };

  const {
    data: chamados,
    isLoading: loadingChamados,
    isFetching: fetchingChamados,
  } = useQuery({
    queryKey: ["GET_CHAMADOS", temChamados],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        if (temChamados) {
          const iniciosComChamados = selected?.filter?.(formTemChamados)?.map((form) => form.inicio) ?? [];
          const response = await Promise.all(iniciosComChamados?.map((ele) => tickets?.getChamadosDetalhe(token, ele as number)));
          if (!response) throw new Error(t("Reports.modalDetailP.errorFetchingTickets"));
          return response;
        }
      }
    },
    enabled: temChamados,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    retry: false,
  });

  const [printTemplate, setPrintTemplate] = useState<PrintTemplateType>({} as PrintTemplateType);
  const [openModalQrCode, setOpenModalQrCode] = useState(false);
  const [openShareModal, setOpenShareModal] = useState(false);

  useEffect(() => {
    if (data && !isLoading && !isFetching) {
      const print = data?.find((elem: PrintTemplateType) => elem.dafaultTemplate);
      if (print) setPrintTemplate(print);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading]);

  const componentRef = useRef(null);

  const handleAfterPrint = useCallback(() => {
    console.info("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = useCallback(() => {
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    pageStyle: {
      padding: "20px",
    },
    contentRef: componentRef,
    documentTitle: selected[0]?.nome,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  const findTeams = (team: equipeReport) => {
    let names: string[][] = [];
    if (team) {
      names = Object.keys(team)?.map((e) => [team[e].nome]);
    }
    return names;
  };

  const camposOcultos = (val: campoOcultosType) => {
    return Object.keys(val)?.map((key) => (
      <>
        <p>{`${key}: ${val[key]}`}</p>
      </>
    ));
  };

  const { mutate: linkDeslogado, isPending: loadingLinkSDeslogado } = useMutation({
    mutationKey: ["GET_LINK"],
    mutationFn: async () => {
      const token = await AttToken();
      if (token) {
        setShowLink(false);
        const response = await reportsService.getLink(
          token,
          null,
          String(selected[0]?.id),
          Number(selected[0]?.inicio),
          String(process.env.REACT_APP_PROJECT_NAME),
        );
        if (selected && selected?.[0]?.hasLink) {
          selected[0].hasLink = "";
        }
        if (!response.message) {
          throw new Error(t("Reports.modalDetailP.errorGeneratingLink"));
        }
        return response.message;
      }
    },
    onSuccess: (data) => {
      setLink(data);
      setShowLink(true);
    },
  });

  const { mutate: linkLogado, isPending: loadingLinkLogado } = useMutation({
    mutationKey: ["GET_LINK"],
    mutationFn: async () => {
      const token = await AttToken();
      if (!token) return;
      const item = Array.isArray(selected) ? selected[0] : selected;
      if (!item) {
        return;
      }
      setShowLink(false);
      const response = await reportsService.getLink(
        token,
        String(item.username),
        null,
        Number(item.inicio),
        String(process.env.REACT_APP_PROJECT_NAME),
      );
      if (item.hasLink) {
        item.hasLink = "";
      }
      if (!response.message) {
        throw new Error(t("Reports.modalDetailP.errorGeneratingLink"));
      }
      return response.message;
    },
    onSuccess: (data) => {
      setLink(data);
      setShowLink(true);
    },
  });

  const { mutate: cancelaExecucao, isPending } = useMutation({
    mutationKey: ["CANCELA_EXECUCAO"],
    mutationFn: async (execucao: ChecklistReportType) => {
      const token = await AttToken();
      if (!token) {
        throw new Error(t("Reports.modalDetailP.invalidToken"));
      }
      const promise = toast.promise(
        async () => {
          const token = await AttToken();
          if (token && execucao.usuario) {
            const response = await ChecklistsService.cancelaExecucao(token, { inicio: execucao.inicio as number, user: execucao.usuario });
            if (!response) {
              throw new Error("Erro ao cancelar execução");
            }
            return response;
          }
        },
        {
          pending: t("checklists.cancelExec"),
          success: t("checklists.cancelaExecSucess"),
          error: t("checklists.cancelaExecErro"),
        },
        { toastId: `cancelamento-${execucao.inicio}` },
      );
      return promise;
    },
    onSuccess: async (data) => {
      if (data.message === "Formulário cancelado!") {
        setOpenModalCancela(false);
        queryClient.refetchQueries({ queryKey: ["GET_REPORTS_DATA"] });
      }
    },
  });

  const linkButton = () => {
    if (selected[0]?.hasLink) return null;

    if (selected[0]?.user) {
      return (
        <Button
          endIcon={<LinkIcon />}
          variant="outlined"
          size="small"
          onClick={() => {
            trackEventMatomo("Modal de visualização de form", "click", "button", "gera link");
            linkLogado();
          }}
          disabled={loadingLinkLogado}>
          {t("Reports.modalDetailP.generateLink")}
        </Button>
      );
    }

    return (
      <Button
        endIcon={<LinkIcon />}
        variant="outlined"
        size="small"
        onClick={() => {
          trackEventMatomo("Modal de visualização de form", "click", "button", "gera link");
          linkDeslogado();
        }}
        disabled={loadingLinkSDeslogado}>
        {t("Reports.modalDetailP.generateLink")}
      </Button>
    );
  };

  const findIdentificador: () => { nome: string; resposta: string } = () => {
    const identifiData = { nome: "", resposta: "" };
    if (!selected?.[0]?.identificadorLista) {
      return identifiData;
    }
    const splitedIdentifi = selected[0].identificadorLista?.split("|");
    const indexItem = Number(splitedIdentifi[2]);
    const indexSub = Number(splitedIdentifi[3]);
    if (!isNaN(indexItem) && !isNaN(indexSub)) {
      const respostaIdentifi = selected?.[0]?.itens?.[indexItem]?.subitens?.[indexSub]?.ocorrencia;
      const nomeIdentifi = selected?.[0]?.itens?.[indexItem]?.subitens?.[indexSub]?.nome;
      identifiData.nome = nomeIdentifi || "";
      identifiData.resposta = respostaIdentifi || "";
      return identifiData;
    } else return identifiData;
  };

  if (!selected) return <p>{t("Reports.modalDetailP.noResponses")}</p>;

  function handleOpen() {
    setShowSettings(!showSettings);
  }

  function handleCancel() {
    trackEventMatomo("Modal de visualização de form", "click", "button", "fecha modal");
    selected
      ?.filter((item) => !item?.editavel?.blockCancel && !item.preenchimentoDeslogado && item?.status === true)
      ?.forEach((item) => {
        delete item.chamados;
        delete item.user;
        delete item.username;
        delete item.formulario;
        delete item.idCliente;
        delete item.idConjunto;
        delete item.idLocal;
        delete item.idUnidade;
        delete item.identificador;
        delete item.subItemIdentificador;
        delete item.foiDelegado;
        delete item.nomeAprovador;
        delete item.aprovacaoStatus;
        delete item.naoConforme;
        delete item.conforme;
        delete item.latitude;
        delete item.longitude;
        delete item.idGerencia;
        delete item.idEmpresa;
        delete item.nomeEmpresa;
        delete item.versaoForm;
        delete item.idForm;
        delete item.isFromAPI;
        item.status = false;
        cancelaExecucao(item);
      });
  }

  function Buttons() {
    return (
      <>
        {window.location.pathname !== "/aprovacao" && (
          <>
            <Button
              variant="outlined"
              size="small"
              color="success"
              endIcon={<PrintIcon />}
              onClick={async (e) => {
                e.preventDefault();
                trackEventMatomo("Modal de visualização de form", "click", "button", "imprime");
                await printFn();
              }}>
              {t("checklists.printConfig.Imprimir")}
            </Button>
            <Button
              variant="outlined"
              size="small"
              endIcon={<RiFileExcel2Fill />}
              onClick={() => {
                trackEventMatomo("Modal de visualização de form", "click", "button", "baixa respostas csv");
                downloadResponsesCSV(selected);
              }}>
              {t("Reports.modalDetailP.downloadCSV")}
            </Button>
            <Button
              variant="outlined"
              size="small"
              endIcon={<ShareIcon />}
              onClick={() => {
                trackEventMatomo("Modal de visualização de form", "click", "button", "compartilha relatórios");
                setOpenShareModal(true);
              }}>
              Compartilhar
            </Button>
            {window.location.pathname.split("/")[1] === "relatorios" && !selected?.[0]?.hasLink && linkButton()}
            {window.location.pathname.split("/")[1] === "relatorios" && selected?.[0]?.modeloQrCode && selected?.[0]?.modeloQrCode && (
              <Button
                variant="outlined"
                size="small"
                color="secondary"
                endIcon={<QrCode2Icon />}
                onClick={() => setOpenModalQrCode(true)}
                disabled={!findIdentificador().nome || !findIdentificador().resposta}>
                {t("Reports.managePreFilledQRCodes")}
              </Button>
            )}
          </>
        )}
        <Button
          size="small"
          color="warning"
          variant="outlined"
          endIcon={<AiFillSetting />}
          onClick={(e) => {
            e.preventDefault();
            setShowSettings(!showSettings);
            trackEventMatomo("Modal de visualização de form", "click", "button", "configurações");
          }}>
          {t("options")}
        </Button>
        {selected?.every((item) => !item?.editavel?.blockCancel
          && !item.preenchimentoDeslogado
          && item?.status === true
          && item.user === userData.id) &&
          (
            <Button
              disabled={isPending}
              endIcon={<DoNotDisturbAltIcon />}
              color="error"
              variant="outlined"
              size="small"
              onClick={() => setOpenModalCancela(true)}>
              {t("checklists.cancelExecution")}
            </Button>
          )}
      </>
    );
  }

  function LinkAndSelect() {
    const valor = Array.isArray(selected) ? selected[0] : selected;
    return (
      <>
        {typeof selected === "object" && (
          <>
            {(showLink || loadingLinkSDeslogado || loadingLinkLogado) && (
              <Stack direction="row" spacing={1} width="100%">
                {!valor?.hasLink && (loadingLinkLogado || loadingLinkSDeslogado) ? (
                  <Skeleton variant="rounded" height={40} width={"100%"} />
                ) : (
                  <TextField disabled variant="outlined" fullWidth label={t("checklists.subitemModal.preenchimento.Link")} value={link || ""} />
                )}
                <Tooltip title={`${t("checklists.subitemModal.preenchimento.copiar")}`}>
                  <IconButton
                    color="success"
                    disabled={!link}
                    onClick={async () => {
                      trackEventMatomo("modal config form", "click", "button", "copia link");
                      if (link) {
                        await navigator.clipboard.writeText(link);
                        alert(`${t("checklists.formModal.linkCopiedToClipboard")}`);
                      }
                    }}>
                    <ContentCopyIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            )}
            {window.location.pathname.split("/")[1] !== "detalhe-checklist" && (
              <>
                {" "}
                {isLoading || isFetching ? (
                  <Skeleton variant="rounded" height={60} width="100%" />
                ) : (
                  <Autocomplete<PrintTemplateType, false, true, true>
                    freeSolo
                    fullWidth
                    value={printTemplate.name ?? ""}
                    disabled={!data?.length}
                    id="combo-box-demo"
                    isOptionEqualToValue={(option, value) => option.id === value.id}
                    filterSelectedOptions
                    disableClearable
                    onClick={() => trackEventMatomo("Modal de visualização de form", "click", "select", "seleciona valor")}
                    options={data
                      ?.filter((template: PrintTemplateType) => template.status === true)
                      ?.sort((a: PrintTemplateType, b: PrintTemplateType) => {
                        return a.name?.toLowerCase() > b.name?.toLowerCase() ? 1 : -1;
                      })
                      ?.map((ele: PrintTemplateType) => ({ ...ele })) ?? []}
                    onChange={(_event, newValue) => {
                      setPrintTemplate(newValue as PrintTemplateType);
                    }}
                    renderOption={(props, option) => (
                      <li {...props} key={option.id}>
                        <span>{option.name}</span>
                      </li>
                    )}
                    renderInput={(params) => <TextField {...params} label={t("checklists.printConfig.Selecione_modelo")} />}
                  />
                )}
              </>
            )}
          </>
        )}
      </>
    );
  }

  return (
    <>
      {showSettings && (
        <ModalOptions
          showRange={showRange}
          setShowRange={setShowRange}
          chamados={chamados as ChamadosArrayType[]}
          temChamados={temChamados}
          showNumbers={showNumbers}
          setShowNumbers={setShowNumbers}
          exibeTipo={exibeTipo}
          setExibeTipo={setExibeTipo}
          ocultaNomeEmpresa={ocultaNomeEmpresa}
          setOcultaNomeEmpresa={setOcultaNomeEmpresa}
          handleOpen={handleOpen}
          open={showSettings}
          form={selected[0]}
          radioOption={radioOption}
          setRadioOption={setRadioOption}
          camposOcultos={selected?.[0]?.camposOcultos as campoOcultosType}
          showNotSelected={showNotSelected}
          setShowNotSelected={setShowNotSelected}
          showScoring={showScoring}
          setShowScoring={setShowScoring}
          showHideFields={showHideFields}
          setShowHideFields={setShowHideFields}
          showHeaders={showHeaders}
          setShowHeaders={setShowHeaders}
          hideHierarchy={hideHierarchy}
          setHideHierarchy={setHideHierarchy}
          hideEquipe={hideEquipe}
          setHideEquipe={setHideEquipe}
          hideUser={hideUser}
          setHideUser={setHideUser}
          hideIdent={hideIdent}
          setHideIdent={setHideIdent}
          hideAprov={hideAprov}
          setHideAprov={setHideAprov}
          hideDate={hideDate}
          setHideDate={setHideDate}
          hideNAplica={hideNAplica}
          setHideNAplica={setHideNAplica}
          showDuplicatas={showDuplicatas}
          setShowDuplicatas={setShowDuplicatas}
          hideFiles={hideFiles}
          setHideFiles={setHideFiles}
          exibeDetalheHospedeiro={exibeDetalheHospedeiro}
          setExibeDetalheHospedeiro={setExibeDetalheHospedeiro}
        />
      )}
      {openAprovation && (
        <ModalAprovation
          refetchAprovation={refetchAprovation}
          openAprovation={openAprovation}
          setOpenAprovation={setOpenAprovation}
          aprove={aprove}
          setAprove={setAprove}
          checklist={Number(selected?.[0]?.inicio)}
          usuarioExecutor={selected?.[0]?.username as string}
          setOpenModal={setOpenModal}
          selected={selected[0]}
        />
      )}
      {openModalQrCode && (
        <ModalQRCode
          openModal={openModalQrCode}
          setOpenModal={setOpenModalQrCode}
          identificador={findIdentificador()}
          id={selected[0]?.idForm || ""}
          selected={selected[0]}
        />
      )}
      {openModalCancela && <CancelExecutionModal
        open={openModalCancela}
        setOpen={setOpenModalCancela}
        handleCancel={handleCancel}
        isLoading={isPending}
        t={t}
      />}
      <ModalShareReports
        open={openShareModal}
        onClose={() => setOpenShareModal(false)}
        reports={selected}
        initialTemplate={printTemplate}
      />
      <ThemeProvider theme={theme}>
        <Dialog scroll="paper" fullWidth maxWidth={"md"} open={openModal} onClose={() => setOpenModal(false)}>
          <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
            {selected[0]?.formulario || t("Filling.visualizacaoForm")}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={() => setOpenModal(false)}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}>
            <CloseIcon />
          </IconButton>
          <DialogActions
            sx={{
              justifyContent: "flex-start",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1,
              marginLeft: "20px",
              "& .MuiButton-root": {
                height: 32,
                minHeight: 32,
                whiteSpace: "nowrap",
              },
            }}>
            <Buttons />
          </DialogActions>
          <DialogContent dividers={true}>
            <Stack
              direction="column"
              alignItems="flex-start"
              justifyContent="flex-start"
              spacing={2}
              width="100%"
              padding={0.5}
              sx={{ marginTop: "20px" }}>
              {isLoadingLink ? (
                <></>
              ) : (
                <>
                  <LinkAndSelect />
                  {window.location.pathname === "/aprovacao" && selected[0].status === "pendente" && (
                    <Stack direction="column" width="100%" spacing={2} alignItems="center" justifyContent="center">
                      <Stack direction="row" justifyContent="space-around" alignItems="center" width="100%">
                        <Button
                          disabled={blocked}
                          endIcon={<TaskAltIcon />}
                          className="button is-success"
                          onClick={() => {
                            setOpenAprovation(true);
                            setAprove("aprovado");
                          }}>
                          {t("checklists.printConfig.Aprovar")}
                        </Button>
                        <Button
                          disabled={blocked}
                          endIcon={<ThumbDownAltIcon />}
                          className="button is-danger"
                          onClick={() => {
                            setOpenAprovation(true);
                            setAprove("reprovado");
                          }}>
                          {t("checklists.printConfig.Reprovar")}
                        </Button>
                      </Stack>
                      {blocked && (
                        <Typography color="textDisabled" variant="subtitle2" fontSize={14} fontWeight={500} component={"p"}>
                          {t("Reports.modalDetailP.pendingApprovalUsers")}{" "}
                          <Typography variant="subtitle2" fontSize={14} fontWeight={600} component={"span"}>
                            {aprovadores?.join(", ") ?? t("Reports.modalDetailP.notAvailable")}
                          </Typography>
                        </Typography>
                      )}
                    </Stack>
                  )}
                  <Stack width="100%" style={{ backgroundColor: "#ffffff" }} ref={componentRef}>
                    {selected?.map((elem, index) => (
                      <DataDetail
                        exibeDetalheHospedeiro={exibeDetalheHospedeiro}
                        showRange={showRange}
                        chamados={chamados?.[index] as ChamadosArrayType ?? []}
                        isLoadingChamados={loadingChamados || fetchingChamados}
                        showNumbers={showNumbers}
                        key={index}
                        executionIndex={index}
                        exibeTipo={exibeTipo}
                        ocultaNomeEmpresa={ocultaNomeEmpresa}
                        showDuplicatas={showDuplicatas}
                        radioOption={radioOption}
                        isLoading={isLoading || isFetching}
                        printTemplate={printTemplate}
                        selected={elem}
                        showHeaders={showHeaders}
                        showScoring={showScoring}
                        findTeams={findTeams}
                        showHideFields={showHideFields}
                        camposOcultos={camposOcultos}
                        hideHierarchy={hideHierarchy}
                        hideEquipe={hideEquipe}
                        hideUser={hideUser}
                        hideIdent={hideIdent}
                        hideAprov={hideAprov}
                        hideDate={hideDate}
                        hideNAplica={hideNAplica}
                        showNotSelected={showNotSelected}
                        hideFiles={hideFiles}
                      />
                    ))}
                  </Stack>
                </>
              )}
            </Stack>
          </DialogContent>
        </Dialog>
      </ThemeProvider>
    </>
  );
}

export default ModalDetailPrint;
